/* eslint-disable */
import axios from '@fs/zion-axios'

const breakNameIntoGroups = (name) => {
  // Library of name parts
  const twoPartNames = ['La', 'Le', 'Mac', 'Mc', 'San', 'Santa', 'Santo', 'Saint', 'Sainte', 'st', 'st.', 'te', 'van', 'van der', 'Von',]
  const prefixes = ['Dr', 'Dr.', 'Professor', 'Mr.', 'Mrs.', 'Ms.', 'Miss', 'Sir', 'Chancelor', 'Principal', 'President', 'Master', 'Lady', 'Lord', 'Warden']
  const suffixes = ['I', 'II', 'III', 'IV', 'Sr.', 'Sr', 'sr', 'Jr.', 'Jr', 'jr', 'vda.', 'vda', 'geb', 'geb.', 'MD',]
  const connectors = ['da', 'das', 'dei', 'Del', 'del', 'della', 'delle', 'la', 'las', 'los', 'De', 'de', 'Di', 'di', 'Do', 'do', 'dos', '&', 'and', 'e', 'y', 'or',]

  // Identify what type the part of the name is
  const identifyPartType = (part) => {
    if (part.match(/\(/)) return 'alternative'
    for (let item of twoPartNames) {
      if (part === item) return 'twoPartName'
    }
    for (let item of prefixes) {
      if (part === item) return 'prefix'
    }
    for (let item of suffixes) {
      if (part === item) return 'suffix'
    }
    for (let item of connectors) {
      if (part === item) return 'connector'
    }
    return 'name'
  }

  // Loop through the name, putting name parts into groups
  const parts = name.split(' ')
  const groups = []
  let group = {}
  let lookahead = {}
  for (let part of parts) {
    part = part.replace(',', '').trim()
    let partType = identifyPartType(part)
    switch (partType) {
      case 'alternative':
        lookahead.alternative = part.replace('(', '').replace(')', '')
        break
      case 'twoPartName':
        if (!group.name) group.name = ''
        group.name += `${part} `
        break
      case 'prefix':
        if (!group.prefixes) group.prefixes = []
        group.prefixes.push(part)
        break
      case 'suffix':
        if (!lookahead.suffixes) lookahead.suffixes = []
        lookahead.suffixes.push(part)
        break
      case 'connector':
        if (!group.connectors) group.connectors = []
        group.connectors.push(part)
        break
      default:
        if (!group.name) group.name = ''
        group.name += part
        lookahead = group
        groups.push(group)
        group = {}
        break
    }
  }
  const filteredGroups = groups.filter(nameObject => nameObject.name !== "")
  return filteredGroups
}

export const checkAsianChar = (ch) => { // taken from discovery aam.es6
  // check if an Asian character was entered
  const REGEX_CHINESE = /[\u4e00-\u9fff]|[\u3400-\u4dbf]|[\u{20000}-\u{2a6df}]|[\u{2a700}-\u{2b73f}]|[\u{2b740}-\u{2b81f}]|[\u{2b820}-\u{2ceaf}]|[\uf900-\ufaff]|[\u3300-\u33ff]|[\ufe30-\ufe4f]|[\uf900-\ufaff]|[\u{2f800}-\u{2fa1f}]/u;
  const REGEX_JAPANESE = /[\u3000-\u303f]|[\u3040-\u309f]|[\u30a0-\u30ff]|[\uff00-\uff9f]|[\u4e00-\u9faf]|[\u3400-\u4dbf]/;
  const REGEX_KOREAN = /[\uac00-\ud7af]|[\u1100-\u11ff]|[\u3130-\u318f]|[\ua960-\ua97f]|[\ud7b0-\ud7ff]/;
  return REGEX_CHINESE.test(ch) || REGEX_JAPANESE.test(ch) || REGEX_KOREAN.test(ch);
}

export const deconstructName = (name) => {
  const isAsian = checkAsianChar(name)
  if(isAsian){
    name = name.split("").join(" ")
  }
  // Example name: "Dr. San Pedro (Peter) Paredes Espinosa de los Monteros III, MD"
  // deconstructName returns:
  // {
  //     firstName: nameObject,
  //     middleNames: [nameObject],
  //     lastname: nameObject
  // }
  //
  // nameObject:
  // {
  //     name: "San Pedro",
  //     alternative: "Peter",
  //     prefixes: ["Dr."],
  //     connectors: ["de los"],
  //     suffixes: ["III","MD"]
  // }

  // get the name groups
  const groups = breakNameIntoGroups(name)
  // construct the output based on the groups
  const response = {}
  if (groups.length) response.firstName = groups[0]
  if (groups.length > 2) response.middleNames = groups.slice(1, groups.length - 1)
  if (groups.length > 1) response.lastName = groups[groups.length - 1]
  return response
}

export const formatName = (rawName = '', { parts, name, nameOrder = 'x-eurotyp', nameDelimiter = 'x-nmspace', language = 'en' } = {}) => {
  // returns a formatted name as a string. Ex: "Dr. San Pedro (Peter) Paredes Espinosa de los Monteros III, MD"
  const languageNameOrderMap = {
    'en': 'x-eurotyp',
    'ko': 'x-sinotyp',
    'zh': 'x-sinotyp',
    'ja': 'x-sinotyp',
  }
  nameOrder = languageNameOrderMap[language] || nameOrder;
  const isAsian = checkAsianChar(rawName)
  if( isAsian ){
    nameDelimiter = "x-nmconcat"
    nameOrder = "x-sinotyp"
  }
  const { firstName, middleNames = [], lastName } = deconstructName(rawName)
  const delimiterMap = {
    'x-nmspace': ' ',
    'x-nmsuffix': ' ',
    'x-nmconcat': '',
    'x-nmdot': '.',
    'x-nmkspace': ' ',
    'x-nmcomma': ',',
  }

  // Order the output based on the nameOrder
  let order
  switch (nameOrder) {
    // case 'x-eurotyp': // given names first
    //   break
    // case 'x-monotyp': // no distinction between given and surname
    //   break
    case 'x-sinotyp': // surnames first
      order = [lastName, firstName, ...middleNames]
      break
    default:
      order = [firstName, ...middleNames, lastName]
      break
  }
  if( isAsian ){
    // Asian names have the last name written first
    switch (name) {
      case 'first':
        order = [lastName, ...middleNames]
        break
      case 'last':
        order = [firstName]
        break
      case 'middle':
        order = [...middleNames]
        break
    }
  } else {
    switch (name) {
      case 'first':
        order = [firstName]
        break
      case 'last':
        order = [lastName]
        break
      case 'middle':
        order = [...middleNames]
        break
    }
  }

  // formats the nameObjects into strings
  const formatNameObject = (nameObject) => {
    let { name, alternative, connectors = [], prefixes = [], suffixes = [] } = nameObject || {}
    if (alternative) alternative = `(${alternative})`
    let include = []
    if (parts) {
      for (let part of parts) {
        if (part === 'prefixes') include.push(...prefixes)
        if (part === 'connectors') include.push(...connectors)
        if (part === 'name') include.push(name)
        if (part === 'alternative') include.push(alternative)
        if (part === 'suffixes' && nameDelimiter !== 'x-nmsuffix' && nameDelimiter !== 'x-nmkspace')
          include.push(...suffixes)
      }
    } else {
      include = [...prefixes, ...connectors, name, alternative]
      if (nameDelimiter !== 'x-nmsuffix' && nameDelimiter !== 'x-nmkspace') include.push(...suffixes)
    }
    if ((nameDelimiter === 'x-nmsuffix' || nameDelimiter === 'x-nmkspace') && nameObject === lastName) {
      return (
        include
          .filter((item) => item !== undefined)
          .join(delimiterMap[nameDelimiter])
          .trim() +
        ((nameDelimiter === 'x-nmsuffix' && nameOrder !== 'x-sinotyp' && !parts) ? ', ' : parts ? '' : ' ') +
        ((parts && !hasSuffixPart) ? '' : suffixes.join(delimiterMap[nameDelimiter]).trim()) +
        ((nameDelimiter === 'x-nmsuffix' && nameOrder === 'x-sinotyp') ? ',' : '')
      )
    }
    return include.filter((item) => item !== undefined).join(delimiterMap[nameDelimiter])
  }
  return (
    order
      // format the nameObjects into strings
      .map((nameObject) => formatNameObject(nameObject))
      // join the name parts by the nameDelimiter
      .join(delimiterMap[nameDelimiter])
      // clean up trailing spaces
      .trim()
  )
}

export const getNameFormatByLocale = (locale) => {
  return axios.get(`/service/standards/core/ws/core/locales/${locale}`)
}
